import { animate, stagger } from 'animejs';
const expandControls = () => {
  const targets = [
    document.querySelector('.mapControls__content'),
    document.querySelector('.mapControls__tabs'),
    document.querySelector('.mapControls__header h1'),
  ];
  const compactTimeline = document.querySelector('.timelineCompact');
  animate(targets, {
    ease: 'linear',
    duration: 300,
    opacity: [1, 0],
  });

  animate(compactTimeline, {
    ease: 'linear',
    duration: 300,
    opacity: [0, 1],
    onBegin: () => {
      compactTimeline.style.display = 'block';
    },
  });
};

const closeControls = () => {
  const targets = [
    document.querySelector('.mapControls__content'),
    document.querySelector('.mapControls__tabs'),
    document.querySelector('.mapControls__header h1'),
  ];
  const compactTimeline = document.querySelector('.timelineCompact');
  animate(targets, {
    ease: 'linear',
    duration: 300,
    opacity: [0, 1],
  });
  animate(compactTimeline, {
    ease: 'linear',
    duration: 100,
    opacity: [1, 0],
    onComplete: () => {
      compactTimeline.style.display = 'none';
    },
  });
};

const hotspotTimeline = () => {
  const hotspots = [...document.querySelectorAll('.mapComponent .hotspot')];
  const timeline = animate(hotspots, {
    autoplay: false,
    ease: 'outElastic(1, .6)',
    opacity: [0, 1],
    translateY: [40, 0],
    delay: stagger(100),
  });
  return timeline;
};

export { expandControls, closeControls, hotspotTimeline };
